import React from 'react';
import styles from './HexLoadingToast.module.css';

interface HexLoadingToastProps {
    progress: number;
    isAdjacency: boolean;
    onClose: () => void;
}

export const HexLoadingToast: React.FC<HexLoadingToastProps> = ({ progress, isAdjacency, onClose }) => {
    const isComplete = progress >= 100;

    return (
        <div className={`${styles.hexToast} ${isComplete ? styles.complete : ''}`}>
            <div className={styles.iconWrapper}>
                {!isComplete ? (
                    <svg className={styles.spinnerSvg} viewBox="0 0 24 24" fill="none">
                        <line x1="12" y1="2" x2="12" y2="6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="16.95" y1="7.05" x2="19.78" y2="4.22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="18" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="16.95" y1="16.95" x2="19.78" y2="19.78" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="12" y1="18" x2="12" y2="22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="4.22" y1="19.78" x2="7.05" y2="16.95" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="2" y1="12" x2="6" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                        <line x1="4.22" y1="4.22" x2="7.05" y2="7.05" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className={styles.tick}/>
                    </svg>
                ) : (
                    <svg className={styles.checkmark} viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="12" fill="#16a34a"/>
                        <path d="M7 12.5l3.5 3.5 6.5-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                )}
            </div>

            <span className={styles.title}>
                {isComplete ? 'Successfully loaded Hexes' : isAdjacency ? 'Loading Adjacency' : 'Loading Hexes'}
            </span>

            {/* <button className={styles.closeButton} onClick={onClose} aria-label="Close">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button> */}

            {/* {!isComplete && (
                <div className={styles.progressBar}>
                    <div className={styles.progressFill} style={{ width: `${Math.min(100, Math.max(0, progress))}%` }} />
                </div>
            )} */}
        </div>
    );
};
